module.exports = __webpack_public_path__ + "media/images/icons/party-2-d9e31339900408949d08313f1bac8cca.svg";